<template>
  <el-container>
    <el-main v-loading="contentLoading" style="padding:0;width:100vh">
      <vm-table
          ref="vmTable"
          :filter.sync="filter"
          module="basic"
          method="post"
          url="sd/so/getAppPageList">
        <!-- url="sd/so/pageList" -->
        <!-- <div slot="toolbar">
          <el-button type="primary" @click="$refs.editPage.open(0)">
            变更申请
          </el-button>
        </div> -->
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="订单编号">
              <el-input v-model.trim="filter.salesOrderNO" clearable placeholder="请输入订单编号"/>
            </vm-search>
            <vm-search label="项目名称">
              <el-input v-model.trim="filter.projectName" clearable placeholder="请输入项目名称"/>
            </vm-search>
            <vm-search label="合同号">
              <el-input v-model.trim="filter.clientContractNO" clearable placeholder="请输入合同号"/>
            </vm-search>
            <vm-search label="SAP订单号">
              <el-input v-model.trim="filter.sAPSalesOrderNO" clearable placeholder="请输入SAP订单号"/>
            </vm-search>
            <vm-search label="发货状态">
              <el-select v-model.trim="filter.deliveryStatusName">
                <el-option label="未发货" value="未发货"/>
                <el-option label="部分发货" value="部分发货"/>
                <el-option label="全部发货" value="全部发货"/>
              </el-select>
            </vm-search>
            <vm-search v-if="draft === 10" label="创建日期">
              <el-date-picker
                  v-model="createDate"
                  :picker-options="pickerOptions"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="createDateChange"/>
            </vm-search>
            <vm-search v-else label="提交日期">
              <el-date-picker
                  v-model="submitTime"
                  :picker-options="pickerOptions"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="submitTimeChange"/>
            </vm-search>
          </div>
        </template>
        <el-table-column prop="salesOrderNO" min-width="100" align="center" label="订单编号">
          <template slot-scope="scope">
            <span
                style="color: #2d8cf0; cursor: pointer"
                @click="$refs.editPage.open({ id: scope.row.pkid, isView: true })">{{scope.row.salesOrderNO}}</span>
            <!-- <el-button
                v-clipboard="scope.row.salesOrderNO"
                v-clipboard:success="clipboardSuccessHandler"
                v-clipboard:error="clipboardErrorHandler"
                round
                icon="el-icon-chat-line-square"/> -->
          </template>
        </el-table-column>
        <el-table-column prop="projectName" align="center" label="项目名称"/>
        <el-table-column prop="clientContractNO" min-width="100" align="center" label="合同号"/>
        <el-table-column min-width="100" align="center" label="要求交期">
          <template slot-scope="scope">
            {{formatDate(scope.row.deliveryDate)}}
          </template>
        </el-table-column>
        <el-table-column prop="sapsalesOrderNO" min-width="100" align="center" label="SAP订单号"/>
        <el-table-column prop="deliveryStatusName" min-width="100" align="center" label="发货状态"/>
        <el-table-column prop="statusName" min-width="80" align="center" label="订单状态"/>
        <el-table-column prop="totalMoney" min-width="100" align="center" label="订单总金额"/>
        <el-table-column min-width="70" align="center" label="查看部件">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handlerViewPart(scope.row.salesOrderNO)">查看</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="amount" min-width="100" align="center" label="SAP总金额"/>
        <el-table-column prop="returnDate" min-width="100" align="center" label="订单来源"/> -->
        <el-table-column
            v-if="draft === 10"
            prop="createDate"
            min-width="100"
            align="center"
            label="创建时间"/>
        <el-table-column
            v-else
            prop="submitTime"
            min-width="100"
            align="center"
            label="提交时间"/>
        <el-table-column
            v-if="draft === 10"
            label="操作"
            align="center"
            class-name="vm-table_operate"
            width="160px"
            fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" @click="$refs.editPage.open({ id: scope.row.pkid })">
              编辑
            </el-button>
            <el-button type="danger" @click="deleteRow(scope.row.pkid)">
              删除
            </el-button>
            <el-button type="success" @click="submit(scope.row.pkid)">
              提交
            </el-button>
          </template>
        </el-table-column>
      </vm-table>
      <order-edit ref="editPage" @save-success="getList(1)"/>

      <!-- 查看部件弹窗，这里展示部件信息 -->
      <el-dialog
          title="查看部件"
          :visible.sync="dialogVisible"
          width="50%">
        <el-table :data="partList">
          <el-table-column type="index" min-width="50" align="center" label="序号"/>
          <el-table-column prop="cabinetCode" min-width="100" label="柜体编号"/>
          <el-table-column prop="courierCode" min-width="100" label="序列号"/>
        </el-table>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";
  import loginUtil from "@/util/loginUtil";
  import OrderEdit from "./OrderEdit.vue";
  // 获取路由的name值
  export default {
    name: "OrderList",
    components: { OrderEdit, VmTable, VmSearch },
    props: {
      draft: { // 10：草稿，20：已提交
        type: Number,
        default: 20,
      },
    },
    data() {
      return {
        constant,
        contentLoading: false,
        currentId: loginUtil.getUserId(),
        ids: [],
        dialogVisible: false,
        partLoading: false,
        partList: [],
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        createDate:[],
        submitTime:[],
        filter: {
          salesOrderNO: "",
          projectName: "",
          clientContractNO: "",
          sAPSalesOrderNO: "",
          creatorName: "",
          beginSubmitTime: "",
          endSubmitTime: "",
          deliveryStatusName: "",
          timeSegment: 2020,
          includeControlBox: -1,
          productType: -1,
          contractAttachment: 0,
        },
      };
    },
    watch: {
      draft: {
        handler(newVal) {
          this.filter.draft = newVal;
        },
        immediate: true,
      },
    },
    mounted() {
      this.setDefaultDateRange();
      this.getList(1);
    },
   
    methods: {
      setDefaultDateRange(picker) {
        const end = new Date();
        const start = new Date();
        start.setMonth(start.getMonth() - 3); // 往前推3个月 = 近3个月
        // start.setDate(1); // 月初
        // 格式化为 LocalDateTime 格式: YYYY-MM-DD HH:mm:ss
        const startStr = `${start.getFullYear()}-${String(start.getMonth() + 1).padStart(2, "0")}-${String(start.getDate()).padStart(2, "0")} 00:00:00`;
        const endStr = `${end.getFullYear()}-${String(end.getMonth() + 1).padStart(2, "0")}-${String(end.getDate()).padStart(2, "0")} 23:59:59`;
        if (this.draft === 10) {
          this.createDate = [startStr, endStr];
          this.filter.beginCreateDate = startStr;
          this.filter.endCreateDate = endStr;
        } else {
          this.submitTime = [startStr, endStr];
          this.filter.beginSubmitTime = startStr;
          this.filter.endSubmitTime = endStr;
        }

        // 给picker刷新用（可选）
        if (picker) {
          picker.$emit("pick", this.dateRange);
        }
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      // 格式化日期，将ISO格式转换为YYYY-MM-DD
      formatDate(dateStr) {
        if (!dateStr) {
          return "";
        }
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) {
          return dateStr;
        }
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      },
      submitTimeChange(date) {
        if (date !== null) {
          this.filter.beginSubmitTime = date[0] + " 00:00:00";
          this.filter.endSubmitTime = date[1] + " 23:59:59";
        } else {
          this.filter.beginSubmitTime = "";
          this.filter.endSubmitTime = "";
        }
      },
      createDateChange(date) {
        if (date !== null) {
          this.filter.beginCreateDate = date[0] + " 00:00:00";
          this.filter.endCreateDate = date[1] + " 23:59:59";
        } else {
          this.filter.beginCreateDate = "";
          this.filter.endCreateDate = "";
        }
      },
      submit(id) {
        this.$confirm("确定提交吗?", "提示", { type: "warning" }).then(() => {
          this.contentLoading = true;
          this.$http.get("basic", `sd/so/submit/${id}`).then(() => {
            this.$message.success("操作成功");
            this.getList(-1);
          }).finally(() => {
            this.contentLoading = false;
          });
        });
      },
      clipboardSuccessHandler(e) {
        this.$message.success("复制单号成功");
      },
      clipboardErrorHandler(e) {
        this.$message.error("复制单号失败");
      },
      deleteRow(id) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.contentLoading = true;
          this.$http
            .get("basic", `sd/so/del/${id}`)
            .then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            }).finally(() => {
              this.contentLoading = false;
            });
        });
      },
      // 查看部件
      handlerViewPart(no) {
        this.partLoading = true;
        this.dialogVisible = true;
        this.$http
          .get("basic", `scanRecords/sub/${no}`)
          .then((res) => {
            this.partList = res;
          }).finally(() => {
            this.partLoading = false;
          });
      },
    },
  };
</script>
<style scoped></style>
